<template>
  <v-card :class="['dress-card', align]" @click="$emit('click', item.id)">
    <v-img width="100%" height="auto" :src="item.photo.src" v-if="item.photo" />
    <v-img height="200px" src="/placeholder.jpg" v-else />
    <div class="card-text">
      <v-card-title>
        {{ item.name }} <v-icon class="ml-5" @click="$router.push({ path: '/model/dress/'+item.id })">mdi-pencil</v-icon>
      </v-card-title>
      <v-card-subtitle class="pb-0">
        <span v-if="item.size" class="mr-5">{{ item.size.name }}</span>
        <span v-if="item.brand">{{ item.brand.name }}</span>
      </v-card-subtitle>
      <v-card-text class="text--primary">
        <div>Цена: {{ item.retailPrice }} руб.</div>
        <div>3 дня: {{ item.rentPrice }} руб.</div>
        <div>2 дня: {{ item.rentPrice*0.75 }} руб.</div>
        <div>1 день: {{ item.rentPrice*0.5 }} руб.</div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  props: ["item", "align"]
};
</script>

<style scoped>
.dress-card {
  height: 100%;
}
.dress-card.left {
  display: flex;
}
.dress-card.left .card-text {
  flex-grow: 1;
}
</style>
